let sharedCtx: AudioContext | null = null;

function getCtx(): AudioContext {
    if (!sharedCtx || sharedCtx.state === 'closed') {
        sharedCtx = new AudioContext();
    }
    return sharedCtx;
}

function playNote(freq: number, startAt: number, duration: number, ctx: AudioContext) {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.12, startAt);
    gain.gain.exponentialRampToValueAtTime(0.001, startAt + duration);
    osc.start(startAt);
    osc.stop(startAt + duration);
}

export function playJoinTone() {
    try {
        const ctx = getCtx();
        const t = ctx.currentTime;
        playNote(880, t, 0.18, ctx);
        playNote(1100, t + 0.12, 0.22, ctx);
    } catch {}
}

export function playLeaveTone() {
    try {
        const ctx = getCtx();
        const t = ctx.currentTime;
        playNote(1100, t, 0.15, ctx);
        playNote(880, t + 0.1, 0.2, ctx);
    } catch {}
}
